<div class="page-wide" ngClass.xs="mobile">
  <h2>MEMBER <span class="font-300">REWARDS</span></h2>

  <div class="greentree-split mt-section row">
    <div class="email-login col">

      <div class="login-container" *ngIf="hasToken">
        <h3>Set your new password</h3>
        <p class="font-300">Don't worry! We will send you an link to reset your password.</p>
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onChangePasswordSubmit()">
        <div class="clr-col">
          <div class="clr-form-control">
            <label for="name" class="clr-control-label">Email</label>
            <input formControlName="email" type="email" id="email" class="form-control" />
          </div>
          <div class="clr-col">
            <div class="clr-form-control">
              <label for="name" class="clr-control-label">Password</label>
              <div class="clr-control-container">
                <div class="clr-input-wrapper">
                  <input formControlName="password" type="password" id="password" class="form-control" />
                </div>
              </div>
            </div>
          </div>
          <div class="clr-col">
            <div class="clr-form-control">
              <label for="name" class="clr-control-label">Confirm Password</label>
              <div class="clr-control-container">
                <div class="clr-input-wrapper">
                  <input formControlName="confirmPassword" type="password" id="confirmPassword" class="form-control" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <button type="submit" class="btn btn-primary" [disabled]="forgotBtnloading || !forgotPasswordForm.valid">Submit</button>
      </form>
      </div>


      <div class="login-container" *ngIf="!hasToken">
        <h3>Reset your password</h3>
        <p class="font-300">Don't worry! We will send you an link to reset your password.</p>
        <form [formGroup]="requestEmailForm" (ngSubmit)="onResetEmailSubmit()">
        <div class="clr-col">
          <div class="clr-form-control">
            <label for="name" class="clr-control-label">Email</label>
            <div class="clr-control-container">
              <div class="clr-input-wrapper">
                <input formControlName="email" type="email" id="email" class="form-control" />
              </div>
            </div>
          </div>
        </div>
        <button type="submit" class="btn btn-primary" [disabled]="!requestEmailForm.valid">Submit</button>
      </form>
      </div>
    </div>

    <div class="register col">
      <h3>Become a rewards member</h3>
      <ul>
        <li>Special Rewards Member Rates</li>
        <li>Complimentary Upgrades*</li>
        <li>Early Check In / Late Check Out*</li>
      </ul>
      <a routerLink="/register">
        <button class="btn btn-outline-primary">REGISTER</button></a>
    </div>
  </div>

</div>